/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {IssuesStateInterface} from '@/store/modules/issues/types';
import {actions} from '@/store/modules/issues/actions';
import {getters} from '@/store/modules/issues/getters';
import {mutations} from '@/store/modules/issues/mutations';


export const state: IssuesStateInterface = {
    currentIssue: undefined,
    currentContributors: undefined,
};

const namespaced: boolean = true;

export const issuesStateModule: Module<IssuesStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,

};
